import { Flag } from "lucide-react";

export default function TaskBubbleDragOverlay({ task }) {
  const subtasks = task.subtasks || [];
  const completedCount = subtasks.filter((s) => s.completed).length;
  const isUrgent = task.urgent || false;

  return (
    <div className={`drag-overlay-bubble task-bubble-${task.category} ${isUrgent ? "urgent" : ""}`}>
      <span className={`bubble-dot dot-${task.category}`} />
      <span className="bubble-name">{task.name}</span>
      {subtasks.length > 0 && (
        <span className="bubble-subtask-badge">
          {completedCount}/{subtasks.length}
        </span>
      )}
      {isUrgent && <Flag size={10} className="bubble-urgent-icon" />}
    </div>
  );
}
